import { formatDate } from '../../../../../utils/format';

export const mountRestTime = ({ intervalStart, intervalEnd }) => {
  const start = formatDate(intervalStart, ' HH:mm');
  const end = formatDate(intervalEnd, ' HH:mm');

  return end ? `${start} - ${end}` : start;
};
